export class ListPickerControlModalItemModel {

    constructor(
        public id: string,
        public primaryField: string,
        public secondaryField: string = "",
        public selected = false,
        public highlighted = false
    ) {

    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-picker-control-modal-item.model.ts